import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import unsplash from "../api/unsplash";
import {TextField,AppBar,Box,Typography,Tab,Tabs,Paper,Grid,Checkbox,FormControlLabel,Card,CardContent,CardHeader,CircularProgress,Button,CardMedia,Divider,CardActions,CardActionArea} from '@mui/material'
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Lavoratori from "./Lavoratori"
import {AccountCircle,AttachFile,Home,Work,Engineering} from '@mui/icons-material';
import '../style/style.scss';
import { Route } from "react-router";
import { useLocation } from "react-router";
import { CSpinner,CImage } from "@coreui/react";
import Mansioni from "./Mansioni";
import Allegati from "./Allegati";
import SistemAziende from "./SistemaAziende";
import Sedi from "./Sedi";

const ClientDetail = (props) => {
  const location = useLocation();
  const [cliente,setCliente] = useState();
  const [oldCliente,setOldCliente] = useState();
  const [value, setValue] = React.useState(0);
  const [lavoratori,setLavoratori] = useState([]);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  const handleInputChange = (e) => {

    let copiaCliente = {...cliente};
    copiaCliente[e.target.name] = e.target.value;

   setCliente(copiaCliente);

    
  }

  const handleCboxChange = (e) => {
    console.log(e.target.checked)
    let copiaCliente = {...cliente};
    copiaCliente[e.target.name] = e.target.checked ? 1:0;

   setCliente(copiaCliente);

    
  }

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      console.log(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
 }

const handleChangeImage =async (e) => {
  const file = e.target.files[0] // prendo la foto caricata sempre nell'evento
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    console.log(reader.result);

      document.getElementById("Logo").src = reader.result;
    cliente.Logo = reader.result.replace("data:image/png;base64,","");
    cliente.Logo = reader.result.replace("data:image/jpeg;base64,","");
  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };


}


//save data 
const saveData = async () => {
try {console.log(cliente.Logo);
 await unsplash.post('updateClienti',{auth : "a5d42c3ed7977afa2d8e922569e7940b",cliente:cliente,idChecklist:cliente.Checklist},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  )
  .then(res => {
      console.log("ok");

    })

    await unsplash.post('storico',{tabella : "Clienti",key:cliente.ID,utente:sessionStorage.getItem("username"),after:cliente,before:oldCliente},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  )
    .then(res => {
        console.log("ok");
  
      })


    alert("salvataggio effettuato");
  } catch{
    alert("errore durante il salvataggio");  }
}

const handleFile = async() =>{
  await unsplash.post('ftp',{operazione : "download"},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  )
  .then(res => {
      console.log("ok");

window.open("http://localhost:3000/file")

    })




}


  useEffect(() => {// è un loop qui carico i dati 
    const fetchData = async () =>{
      try {
console.log(location.state)
        let responseAziendali = unsplash
          .get('lavoratori',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:location.state.idC}}
           );
          console.log(responseAziendali);
         setLavoratori(responseAziendali);
    
                  let response = await  unsplash.post('clientDetail',
                                        {auth : "a5d42c3ed7977afa2d8e922569e7940b",id:location.state.idC},
                                        { headers: {
                                                    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
                                                   }
                                        } );
                          
                                        setCliente(response.data.data[0]);
                                        setOldCliente(response.data.data[0]);
                  
                  



      } catch (error) {
        console.error(error.message);
      }

    }

    fetchData();
 
  }, []);




return(
<Grid item xs={12}>

<Card>
  <CardHeader sx={{textAlign:"center"}} title={location.state.RagioneSociale}  titleTypographyProps={{variant:'h4' }}/>
  </Card>
  <Card sx={{marginTop:"10px"}}>
  <CardContent>
  <Box sx={{ width: '100%'}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable">
          <Tab icon={<Work />}  iconPosition="start" label="Dati Aziendali" {...a11yProps(0)} />
          <Tab icon={<AccountCircle />} iconPosition="start"  label="Lavoratori" {...a11yProps(1)}  />
          <Tab icon={<AttachFile />} iconPosition="start"   label="Allegati" {...a11yProps(2)} />
          <Tab icon={<Home />}  iconPosition="start" label="Sedi" {...a11yProps(3)} />
          <Tab icon={<Engineering />}  iconPosition="start" label="Mansioni" {...a11yProps(4)} />
  
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
      {cliente === undefined?(<div><center><CircularProgress  color="primary"/></center></div>)
:
(

<div>
<Grid container spacing={2} >
<Grid item xs={12} md={4} sx={{textAlign:"center"}}>

</Grid>
<Grid item xs={12} md={4} sx={{textAlign:"center"}}>

<Card>
    <CardContent>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
          <CardActionArea   onClick={() => {document.getElementById("file").click()}} >
         <CardMedia
          component="img"
          height="140"
          image={cliente.Logo!==""?"data:image/png;base64,"+cliente.Logo:require("../assets/images/MILLERLogo.jpg").default}
          src={cliente.Logo!==""?"data:image/png;base64,"+cliente.Logo:require("../assets/images/MILLERLogo.jpg").default}
       
          alt="img"
        />
     </CardActionArea >
      </Box>
    </CardContent>
    <Divider />
    <CardActions>
      <Button
        fullWidth
        variant="text"
   onClick={() => {document.getElementById("file").click()}} 

      >
        Carica Foto
      </Button>
    </CardActions>
  </Card>

<input type='file' id='file' accept="image/*" onChange={(e) => handleChangeImage(e)} style={{display: 'none'}}/>

</Grid>

<Grid item xs={12} md={4} sx={{textAlign:"center"}}>

</Grid>

<Grid item xs={12} md={6}>

<TextField id="standard-basic" fullWidth  onChange={(e) => handleInputChange(e)} name="RagioneSociale" label="Ragione Sociale"  defaultValue={cliente.RagioneSociale} />
</Grid>
<Grid item xs={12} md={6}>

<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="Email" label="Email"  defaultValue={cliente.Email} />
</Grid>
<Grid item xs={12} md={6}>

<TextField id="standard-basic" fullWidth  onChange={(e) => handleInputChange(e)} name="CF" label="Codice Fiscale"  defaultValue={cliente.CF} />
</Grid>
<Grid item xs={12} md={6}>

<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="PIVA" label="Partita IVA"  defaultValue={cliente.PIVA} />
</Grid>
<Grid item xs={12} md={6}>

<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="Telefono" label="Telefono"  defaultValue={cliente.Telefono} />
</Grid>



<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="SedeIndirizzo" label="Sede Indirizzo"  defaultValue={cliente.SedeIndirizzo} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="SedeLocalita" label="Sede Località"  defaultValue={cliente.SedeLocalita} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="SedeCAP" label="Sede CAP"  defaultValue={cliente.SedeCAP} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="CDC" label="Centro di costo"  defaultValue={cliente.CDC} />
</Grid>

<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="PostIndirizzo" label="Posta Indirizzo"  defaultValue={cliente.PostIndirizzo} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="PostLocalita" label="Posta Località"  defaultValue={cliente.PostLocalita} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="PostCAP" label="Posta CAP"  defaultValue={cliente.PostCAP} />
</Grid>
<Grid item xs={12} md={6}>
<TextField id="standard-basic" fullWidth onChange={(e) => handleInputChange(e)} name="CodiceATECO" label="Codice Ateco"  defaultValue={cliente.CodiceATECO} />
</Grid>
<Grid item xs={12} md={6} sx={{marginLeft:"20px"}}>
<FormControlLabel control={<Checkbox name="GestioneMedicina" checked={cliente.GestioneMedicina===1?true:false}  onChange={(e) =>handleCboxChange(e) } />} label="Gestione Medicina" />
<FormControlLabel control={<Checkbox name="GestioneCorsi" checked={cliente.GestioneCorsi===1?true:false} onChange={(e) =>handleCboxChange(e) } />} label="Gestione Corsi" />
</Grid>
<Grid item xs={12} md={6} sx={{marginLeft:"20px"}}>
<FormControlLabel control={<Checkbox name="GestioneSopralluoghi" checked={cliente.GestioneSopralluoghi===1?true:false} onChange={(e) =>handleCboxChange(e) }  />} label="Gestione Sopralluoghi" />
<FormControlLabel control={<Checkbox name="InvioSollMedico" checked={cliente.InvioSollMedico===1?true:false} onChange={(e) =>handleCboxChange(e) }  />} label="Considera Sollecito Idoneità Medici" />
</Grid>
<Grid item xs={12} md={2}>
<Button variant="contained" onClick={() => saveData()}> SALVA </Button>

</Grid>
<Grid item xs={12} md={2}>
<SistemAziende/>
</Grid>


</Grid>
</div>)
  
  
  
  }
      </TabPanel>
      <TabPanel value={value} index={1}>
      {
            cliente === undefined?<CircularProgress  color="primary"/>:<Lavoratori Lavoratori={lavoratori} idAzienda={cliente.ID}/>}
      </TabPanel>
      <TabPanel value={value} index={2}>
      {
            cliente === undefined?<CircularProgress  color="primary"/>:<Allegati idAzienda={cliente.ID}/>}
      </TabPanel>
      <TabPanel value={value} index={3}>
      {
            cliente === undefined?<CircularProgress  color="primary"/>:<Sedi idAzienda={cliente.ID}/>}
   
      </TabPanel>
      <TabPanel value={value} index={4}>
      {
            cliente === undefined?<CircularProgress color="primary"/>:<Mansioni idAzienda={cliente.ID}/>}

      </TabPanel>
    </Box>

 </CardContent> 
 </Card>

</Grid>
)
}

  



  //`data:image/png;base64,${this.state.cliente.Logo}`    


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  

  export default ClientDetail
